import ClientItem from 'owa-mail-store/lib/store/schema/ClientItem';
import { lazySmimeAdapter } from 'owa-smime-adapter';
import smimeStore from 'owa-smime-adapter/lib/store/store';
import { isInitialized } from 'owa-smime-adapter/lib/utils/smimeUtils';
import {
    mergeSmimeViewStates,
    getSmimeViewStateWithAdminSettings,
    getSmimeViewStateWithUserSettings,
    getSmimeViewStateFromParentItem,
} from './smimeViewStateUtil';

export default async function getMergedSmimeViewState(parentItem?: ClientItem) {
    if (!isInitialized(smimeStore.installationStatus)) {
        /**
         * Initialize S/MIME adapter if we are going to respond with
         * an S/MIME mail.
         */
        await lazySmimeAdapter.import();
    }
    /**
     * Priority order for S/MIME settings
     * 1. SmimeAdminSettings
     * 2. SmimeUserSettings
     * 3. ParentItemSmimeSetting
     */
    return mergeSmimeViewStates([
        getSmimeViewStateWithAdminSettings(),
        getSmimeViewStateWithUserSettings(),
        getSmimeViewStateFromParentItem(parentItem),
    ]);
}
